/**
 * AuthThreadMini — A calm, ambient Thread for auth left panels.
 * 280×30px, single packet, 3.5s cycle (trustworthy pacing).
 * Reused across Login, Register, ForgotPassword, TwoFactor.
 */
export default function AuthThreadMini({ color = "var(--color-success)" }) {
  return (
    <svg
      viewBox="0 0 280 30"
      fill="none"
      aria-hidden="true"
      style={{ width: "280px", height: "30px", overflow: "visible" }}
    >
      <defs>
        <linearGradient id="atm-grad" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%"   stopColor={color} stopOpacity="0" />
          <stop offset="25%"  stopColor={color} />
          <stop offset="75%"  stopColor={color} />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
        <filter id="atm-glow" x="-60%" y="-200%" width="220%" height="500%">
          <feGaussianBlur stdDeviation="2" result="b" />
          <feMerge><feMergeNode in="b" /><feMergeNode in="SourceGraphic" /></feMerge>
        </filter>
      </defs>

      <path
        id="atm-path"
        d="M 0 15 C 70 4, 140 26, 210 15 S 260 8, 280 15"
        stroke="url(#atm-grad)"
        strokeWidth="1.2"
        fill="none"
        strokeDasharray="6 5"
        opacity="0.55"
        style={{ animation: "dashMove 1.8s linear infinite" }}
      />

      {/* Source anchor */}
      <circle cx="0"   cy="15" r="4.5" fill="none" stroke={color} strokeWidth="1" opacity="0.30" />
      <circle cx="0"   cy="15" r="2.2" fill={color} opacity="0.50" />
      {/* Destination anchor */}
      <circle cx="280" cy="15" r="4.5" fill="none" stroke={color} strokeWidth="1" opacity="0.30" />
      <circle cx="280" cy="15" r="2.2" fill={color} opacity="0.50" />

      {/* Glow halo */}
      <circle r="8" fill={color} opacity="0.18" filter="url(#atm-glow)">
        <animateMotion dur="3.5s" repeatCount="indefinite"><mpath href="#atm-path" /></animateMotion>
      </circle>
      {/* Main packet */}
      <circle r="4" fill={color}>
        <animateMotion dur="3.5s" repeatCount="indefinite"><mpath href="#atm-path" /></animateMotion>
      </circle>
      {/* Core */}
      <circle r="1.8" fill="white">
        <animateMotion dur="3.5s" repeatCount="indefinite"><mpath href="#atm-path" /></animateMotion>
      </circle>
    </svg>
  );
}
